import React from 'react';

import { RulesHoriziontalNet, RulesVerticalNet } from './rulesNet';

interface DroneSoccerRulesProps {
  windowWidth: number;
}

export const DroneSoccerRules: React.FC<DroneSoccerRulesProps> = ({
  windowWidth,
}) => {
  return (
    <section className="soccer-rules-section">
      <h2 className="soccer-rules-title">Rules</h2>
      <div className="soccer-rules-cards">
        <div className="soccer-rules-card-content">
          <div className="soccer-rules-card-noise" />
          <div className="soccer-rules-card-icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="221"
              height="234"
              viewBox="0 0 221 234"
              fill="none"
              className="soccer-rules-card-icon"
            >
              <g filter="url(#filter0_dd_3884_1523)">
                <path
                  d="M162.567 225.497L146 208.931L164.638 189.997L146 171.36L162.567 154.497L181.5 173.431L200.137 154.497L217 171.36L198.067 189.997L217 208.931L200.137 225.497L181.5 206.86L162.567 225.497ZM39.5 201.831C42.8528 201.831 45.6652 200.695 47.9372 198.423C50.2092 196.151 51.3412 193.342 51.3333 189.997C51.3254 186.652 50.1894 183.844 47.9253 181.572C45.6612 179.3 42.8528 178.164 39.5 178.164C36.1472 178.164 33.3388 179.3 31.0747 181.572C28.8106 183.844 27.6746 186.652 27.6667 189.997C27.6588 193.342 28.7948 196.155 31.0747 198.435C33.3546 200.714 36.163 201.846 39.5 201.831ZM39.5 225.497C29.6389 225.497 21.2569 222.046 14.3542 215.143C7.45139 208.24 4 199.859 4 189.997C4 180.136 7.45139 171.754 14.3542 164.852C21.2569 157.949 29.6389 154.497 39.5 154.497C46.7972 154.497 53.4554 156.521 59.4747 160.568C65.4939 164.615 69.8801 170.086 72.6333 176.981C80.325 174.811 86.5888 170.571 91.4247 164.26C96.2605 157.949 98.6746 150.75 98.6667 142.664V95.3307C98.6667 78.9613 104.437 65.0098 115.979 53.4762C127.52 41.9427 141.472 36.172 157.833 36.1641H171.442L152.804 17.5266L169.667 0.664062L217 47.9974L169.667 95.3307L152.804 78.7641L171.442 59.8307H157.833C147.972 59.8307 139.59 63.2821 132.688 70.1849C125.785 77.0877 122.333 85.4696 122.333 95.3307V142.664C122.333 157.061 117.699 169.735 108.429 180.685C99.1597 191.634 87.425 198.387 73.225 200.943C70.8583 208.24 66.5668 214.157 60.3503 218.693C54.1339 223.229 47.1838 225.497 39.5 225.497ZM20.5667 83.4974L4 66.9307L22.6375 47.9974L4 29.3599L20.5667 12.4974L39.5 31.4307L58.1375 12.4974L75 29.3599L56.0667 47.9974L75 66.9307L58.1375 83.4974L39.5 64.8599L20.5667 83.4974Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_dd_3884_1523"
                  x="0"
                  y="0.664062"
                  width="221"
                  height="232.836"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3884_1523"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_3884_1523"
                    result="effect2_dropShadow_3884_1523"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_3884_1523"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="soccer-rules-card-text">
            <h3 className="soccer-rules-card-title">Team & Arena</h3>
            <p className="soccer-rules-card-description">
              Teams of five (Striker, Forward, Center, Sweeper, Keeper) play in
              a netted arena. Matches are played in a best-of-three format, with
              each set lasting three minutes.
            </p>
          </div>
        </div>
        <div className="soccer-rules-card-content">
          <div className="soccer-rules-card-noise" />
          <div className="soccer-rules-card-icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="285"
              height="284"
              viewBox="0 0 285 284"
              fill="none"
              className="soccer-rules-card-icon"
            >
              <g filter="url(#filter0_dd_3884_1532)">
                <g filter="url(#filter1_dd_3884_1532)">
                  <path
                    d="M67.5594 156.531C70.4023 155.538 73.5172 155.665 76.2693 156.888C79.0214 158.111 81.2036 160.338 82.3713 163.114C83.5391 165.89 83.6044 169.007 82.5541 171.829C81.5038 174.652 79.4168 176.967 76.7184 178.305L75.4404 178.849C71.7417 180.157 68.4259 182.363 65.7909 185.27C63.156 188.176 61.2845 191.692 60.3446 195.501C59.4048 199.309 59.426 203.292 60.4064 207.091C61.3868 210.889 63.2957 214.385 65.9615 217.263C68.6273 220.141 71.9664 222.312 75.6789 223.58C79.3913 224.849 83.3607 225.174 87.2303 224.529C91.0999 223.883 94.7485 222.286 97.8481 219.881C100.948 217.477 103.401 214.339 104.988 210.752L105.663 209.06C106.147 207.553 106.929 206.16 107.962 204.961C108.994 203.762 110.257 202.782 111.675 202.08C113.092 201.378 114.637 200.967 116.216 200.872C117.795 200.776 119.378 200.999 120.87 201.526C122.361 202.053 123.732 202.874 124.901 203.94C126.07 205.006 127.014 206.296 127.676 207.733C128.338 209.171 128.705 210.726 128.755 212.307C128.805 213.889 128.538 215.464 127.969 216.941C125.305 224.483 120.773 231.228 114.797 236.545C108.821 241.862 101.595 245.579 93.7942 247.348C85.993 249.116 77.8709 248.88 70.1859 246.66C62.501 244.44 55.5038 240.309 49.8475 234.652C44.1913 228.996 40.0603 221.999 37.8403 214.314C35.6203 206.629 35.3836 198.507 37.1523 190.706C38.921 182.905 42.6375 175.679 47.9548 169.703C53.272 163.727 60.0168 159.195 67.5594 156.531ZM217.44 156.531C224.983 159.195 231.728 163.727 237.045 169.703C242.362 175.679 246.079 182.905 247.847 190.706C249.616 198.507 249.379 206.629 247.159 214.314C244.939 221.999 240.808 228.996 235.152 234.652C229.496 240.309 222.499 244.44 214.814 246.66C207.129 248.88 199.007 249.116 191.206 247.348C183.404 245.579 176.179 241.862 170.202 236.545C164.226 231.228 159.695 224.483 157.031 216.941C156.038 214.098 156.165 210.983 157.388 208.231C158.611 205.479 160.838 203.296 163.614 202.129C166.39 200.961 169.506 200.895 172.329 201.946C175.151 202.996 177.467 205.083 178.805 207.782L179.349 209.06C180.657 212.758 182.863 216.074 185.769 218.709C188.676 221.344 192.192 223.215 196 224.155C199.809 225.095 203.792 225.074 207.591 224.093C211.389 223.113 214.885 221.204 217.763 218.538C220.641 215.873 222.812 212.533 224.08 208.821C225.348 205.109 225.674 201.139 225.029 197.27C224.383 193.4 222.786 189.751 220.381 186.652C217.977 183.552 214.839 181.099 211.252 179.512L209.559 178.849C208.094 178.332 206.745 177.53 205.589 176.492C204.433 175.453 203.493 174.196 202.823 172.794C201.469 169.963 201.296 166.709 202.341 163.75C203.386 160.79 205.564 158.367 208.396 157.013C211.227 155.66 214.481 155.486 217.44 156.531ZM95.2967 78.5733L96.5156 79.4017L127.969 103.873C131.85 106.893 136.577 108.628 141.49 108.838C146.404 109.048 151.261 107.722 155.386 105.045L157.031 103.873L188.484 79.4135C190.66 77.7189 193.36 76.8375 196.116 76.9217C198.873 77.006 201.514 78.0504 203.582 79.8747C205.651 81.699 207.017 84.1885 207.445 86.9131C207.873 89.6377 207.336 92.4262 205.927 94.7968L205.098 96.0157L180.627 127.469C177.607 131.351 175.871 136.077 175.661 140.99C175.452 145.904 176.778 150.761 179.455 154.887L180.627 156.531L205.086 187.984C206.781 190.16 207.662 192.86 207.578 195.617C207.494 198.373 206.449 201.014 204.625 203.082C202.801 205.151 200.311 206.517 197.587 206.945C194.862 207.373 192.074 206.836 189.703 205.427L188.484 204.598L157.031 180.127C153.149 177.107 148.423 175.372 143.509 175.162C138.596 174.952 133.739 176.278 129.613 178.956L127.969 180.127L96.5156 204.587C94.3396 206.281 91.6401 207.162 88.8833 207.078C86.1266 206.994 83.4859 205.95 81.4175 204.125C79.349 202.301 77.9827 199.812 77.5547 197.087C77.1267 194.362 77.6638 191.574 79.0732 189.203L79.9016 187.984L104.373 156.531C107.393 152.649 109.128 147.923 109.338 143.01C109.548 138.096 108.222 133.239 105.544 129.114L104.373 127.469L79.9134 96.0157C78.2923 93.9373 77.4116 91.3771 77.4108 88.7413C77.4101 86.1054 78.2895 83.5448 79.9094 81.4655C81.5294 79.3862 83.7972 77.9072 86.3532 77.2633C88.9091 76.6193 91.6069 76.8472 94.0187 77.9107L95.2967 78.5733ZM201.667 35.5C212.836 35.4949 223.648 39.4402 232.19 46.6381C240.731 53.836 246.452 63.8227 248.34 74.8319C250.229 85.8411 248.163 97.1633 242.508 106.796C236.853 116.429 227.974 123.751 217.44 127.469C214.597 128.462 211.483 128.335 208.73 127.112C205.978 125.889 203.796 123.662 202.628 120.886C201.461 118.11 201.395 114.994 202.446 112.171C203.496 109.348 205.583 107.033 208.281 105.695L209.559 105.151C213.258 103.843 216.574 101.637 219.209 98.7305C221.844 95.824 223.715 92.3084 224.655 88.4995C225.595 84.6907 225.574 80.708 224.593 76.9094C223.613 73.1108 221.704 69.6153 219.038 66.737C216.373 63.8588 213.033 61.688 209.321 60.4198C205.608 59.1515 201.639 58.8256 197.77 59.4712C193.9 60.1168 190.251 61.7137 187.152 64.1185C184.052 66.5233 181.599 69.6606 180.012 73.2483L179.349 74.9405C178.304 77.9 176.126 80.3232 173.294 81.6768C170.463 83.0306 167.209 83.2039 164.25 82.1588C161.29 81.1138 158.867 78.9358 157.513 76.1041C156.16 73.2725 155.986 70.019 157.031 67.0595C160.294 57.8288 166.338 49.837 174.332 44.1848C182.326 38.5327 191.876 35.4984 201.667 35.5ZM83.3332 35.5C93.1235 35.4984 102.673 38.5327 110.667 44.1848C118.661 49.837 124.706 57.8288 127.969 67.0595C128.962 69.9025 128.835 73.0173 127.612 75.7694C126.389 78.5215 124.162 80.7037 121.386 81.8715C118.61 83.0392 115.493 83.1045 112.671 82.0542C109.848 81.0039 107.533 78.9169 106.195 76.2185L105.651 74.9405C104.343 71.2418 102.137 67.926 99.2304 65.291C96.3239 62.6561 92.8082 60.7846 88.9994 59.8447C85.1905 58.9049 81.2079 58.9261 77.4092 59.9065C73.6106 60.8869 70.1151 62.7958 67.2369 65.4616C64.3587 68.1274 62.1879 71.4665 60.9196 75.179C59.6514 78.8914 59.3254 82.8608 59.971 86.7304C60.6167 90.6 62.2136 94.2486 64.6184 97.3482C67.0232 100.448 70.1604 102.901 73.7482 104.488L75.4404 105.163C78.3144 106.271 80.6431 108.456 81.9316 111.254C83.2201 114.052 83.3669 117.242 82.3408 120.146C81.3146 123.05 79.1965 125.44 76.4363 126.807C73.6762 128.175 70.4916 128.412 67.5594 127.469C57.0401 123.739 48.1766 116.413 42.5333 106.784C36.8901 97.1551 34.83 85.8419 36.7167 74.8417C38.6033 63.8414 44.3155 53.8614 52.8449 46.6631C61.3742 39.4648 72.1724 35.5111 83.3332 35.5Z"
                    fill="white"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_dd_3884_1532"
                  x="-6.01953"
                  y="-2.5"
                  width="297.041"
                  height="297.016"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="-12" />
                  <feGaussianBlur stdDeviation="6" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                  />
                  <feBlend
                    mode="overlay"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3884_1532"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="21" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
                  />
                  <feBlend
                    mode="overlay"
                    in2="effect1_dropShadow_3884_1532"
                    result="effect2_dropShadow_3884_1532"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_3884_1532"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_dd_3884_1532"
                  x="31.9805"
                  y="35.5"
                  width="221.041"
                  height="221.016"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3884_1532"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_3884_1532"
                    result="effect2_dropShadow_3884_1532"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_3884_1532"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="soccer-rules-card-text">
            <h3 className="soccer-rules-card-title">F9A-B Class</h3>
            <p className="soccer-rules-card-description">
              Drones must weigh under{' '}
              <span style={{ whiteSpace: 'nowrap' }}>300 g</span> and fit within
              a <span style={{ whiteSpace: 'nowrap' }}>20±2 cm</span> spherical
              cage. Built for contact play, each drone features LED colors for
              pilot roles and must pass safety checks.
            </p>
          </div>
        </div>
        <div className="soccer-rules-card-content">
          <div className="soccer-rules-card-noise" />
          <div className="soccer-rules-card-icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="293"
              height="186"
              viewBox="0 0 293 186"
              fill="none"
              className="soccer-rules-card-icon"
            >
              <g filter="url(#filter0_dd_3884_1540)">
                <path
                  d="M105.578 3.94714C126.757 -1.82897 140.877 1.5403 145.291 3.94714L288.5 102.629L269.246 148.36L204.259 177.242L154.918 144.75C147.698 139.996 129.646 149.571 105.578 159.198C81.5088 168.825 10.5059 168.825 4.90672 99.0262C0.427524 43.1876 34.0504 22.0479 51.4223 18.4579C60.6486 16.0279 84.3972 9.72361 105.578 3.94714ZM277.462 111.017L219.104 138.29L218.92 138.376L218.848 138.566L208.407 166.245L207.986 167.363L209.078 166.879L265.639 141.81L265.823 141.728L265.899 141.543L278.137 111.66L278.622 110.475L277.462 111.017ZM107.626 88.3885C102.489 59.1104 78.652 37.0756 52.8979 41.5956C27.1449 46.1165 12.2365 74.9507 17.3735 104.228C22.511 133.507 46.3463 155.543 72.1001 151.024C97.8543 146.504 112.764 117.667 107.626 88.3885ZM54.7593 52.1991C73.1705 48.968 92.9044 64.8933 97.3442 90.1932C101.784 115.494 88.6512 137.19 70.2397 140.422C51.8285 143.652 32.0952 127.724 27.6557 102.424C23.2168 77.1242 36.3486 55.4312 54.7593 52.1991ZM151.171 15.5126L98.2202 31.1571L97.2075 31.4569L98.0806 32.0507L128.166 52.5087L128.384 52.6571L128.629 52.5614L177.97 33.3055L178.889 32.9471L178.057 32.4188L151.582 15.5702L151.389 15.4481L151.171 15.5126Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_dd_3884_1540"
                  x="0.5"
                  y="0.757812"
                  width="292"
                  height="184.484"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3884_1540"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_3884_1540"
                    result="effect2_dropShadow_3884_1540"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_3884_1540"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="soccer-rules-card-text">
            <h3 className="soccer-rules-card-title">Regulations</h3>
            <p className="soccer-rules-card-description soccer-rules-card-description-padding">
              Designed for indoor arenas and school use. No FAA registration
              required. Safe, netted environments support legal, structured play
              and hands-on learning.
            </p>
          </div>
        </div>
      </div>
      <div className="soccer-rules-net-container">
        {windowWidth > 1500 ? <RulesHoriziontalNet /> : <RulesVerticalNet />}
      </div>
    </section>
  );
};
